
URL = globalThis.URL
import __vite__wasmUrl from "/home/ubuntu/invoicer/lauder/invoicer-app/node_modules/@dqbd/tiktoken/tiktoken_bg.wasm?url"
import __vite__initWasm from "/__vite-plugin-wasm-helper"
import * as __vite__wasmImport_0 from "./tiktoken_bg.js";
const __vite__wasmModule = await __vite__initWasm({ "./tiktoken_bg.js": { "__wbindgen_object_drop_ref": __vite__wasmImport_0["__wbindgen_object_drop_ref"],
"__wbindgen_is_undefined": __vite__wasmImport_0["__wbindgen_is_undefined"],
"__wbg_stringify_f4f701bc34ceda61": __vite__wasmImport_0["__wbg_stringify_f4f701bc34ceda61"],
"__wbindgen_string_get": __vite__wasmImport_0["__wbindgen_string_get"],
"__wbindgen_error_new": __vite__wasmImport_0["__wbindgen_error_new"],
"__wbg_parse_161c68378e086ae1": __vite__wasmImport_0["__wbg_parse_161c68378e086ae1"],
"__wbindgen_throw": __vite__wasmImport_0["__wbindgen_throw"] } }, __vite__wasmUrl);
export const memory = __vite__wasmModule.memory;
export const __wbg_tiktoken_free = __vite__wasmModule.__wbg_tiktoken_free;
export const tiktoken_new = __vite__wasmModule.tiktoken_new;
export const tiktoken_name = __vite__wasmModule.tiktoken_name;
export const tiktoken_encode = __vite__wasmModule.tiktoken_encode;
export const tiktoken_encode_ordinary = __vite__wasmModule.tiktoken_encode_ordinary;
export const tiktoken_encode_with_unstable = __vite__wasmModule.tiktoken_encode_with_unstable;
export const tiktoken_encode_single_token = __vite__wasmModule.tiktoken_encode_single_token;
export const tiktoken_decode = __vite__wasmModule.tiktoken_decode;
export const tiktoken_decode_single_token_bytes = __vite__wasmModule.tiktoken_decode_single_token_bytes;
export const tiktoken_token_byte_values = __vite__wasmModule.tiktoken_token_byte_values;
export const get_encoding = __vite__wasmModule.get_encoding;
export const encoding_for_model = __vite__wasmModule.encoding_for_model;
export const __wbindgen_export_0 = __vite__wasmModule.__wbindgen_export_0;
export const __wbindgen_export_1 = __vite__wasmModule.__wbindgen_export_1;
export const __wbindgen_export_2 = __vite__wasmModule.__wbindgen_export_2;
export const __wbindgen_add_to_stack_pointer = __vite__wasmModule.__wbindgen_add_to_stack_pointer;
export const __wbindgen_export_3 = __vite__wasmModule.__wbindgen_export_3;
